/** The API access page's tabs; the value is also its `?tab=` query param. */
export enum ApiAccessTab {
  Keys = 'keys',
  Webhooks = 'webhooks',
}
